import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { StockChart, Chart } from 'angular-highcharts';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Meta, Title } from '@angular/platform-browser';


@Component({
  selector: 'app-battery-list',
  templateUrl: './battery-list.component.html',
  styleUrls: ['./battery-list.component.css']
})
export class BatteryListComponent implements OnInit {

  battery: StockChart;

  constructor(private http: HttpClient,
    private meta: Meta,
    private titleService: Title) {
    this.meta.updateTag({ name: 'title', content: 'Wheatherman - battery list' });
    this.meta.updateTag({ name: 'description', content: 'Wheatherman - battery list' });
    this.meta.updateTag({ name: 'keywords', content: 'Wheatherman - battery list' });
    this.titleService.setTitle('Wheatherman');
  }

  ngOnInit() {
    this.listValueBattery();
  }

  listValueBattery() {
    this.http.get(`${environment.apiUrl}/batteryList.php`)
      .subscribe((res: any) => {
        console.log('json battery', res);
        this.battery = new StockChart({
          rangeSelector: {
            selected: 1
          },
          title: {
            text: 'History Battery'
          },
          time: {
            useUTC: false,
            timezoneOffset: 3600,
            timezone: 'Europe/Rome'
          },
          series: [{
            tooltip: {
              valueDecimals: 2
            },
            name: 'perc. ',
            data:  res

          }]
        } as any);
      });

  }

  // add point to chart serie
  refrash() {
    this.listValueBattery()
  }

}
